export const START_COLUMN = "contacte";

export const COLUMNS = [
  { id: "contacte", title: "Contacté", color: "#C98BA0", desc: "1er message ou audio envoyé. La carte passe automatiquement dans « À relancer (1ère relance) » 2 jours après.", delay: { value: 2, unit: "j" }, autoTo: "arelancer1" },
  { id: "arelancer1", title: "À relancer (1ère relance)", color: "#7B113A", desc: "Envoie ta 1ère relance, puis glisse la carte dans « 1ère relance faite ».", todo: true },
  { id: "relance1", title: "1ère relance faite ✅", color: "#B0607E", desc: "La carte passe automatiquement dans « À relancer (2ème relance) » 4 jours après.", delay: { value: 4, unit: "j" }, autoTo: "arelancer2" },
  { id: "arelancer2", title: "À relancer (2ème relance)", color: "#7B113A", desc: "Envoie ta 2ème relance, puis glisse la carte dans « 2ème relance faite ».", todo: true },
  { id: "relance2", title: "2ème relance faite ✅", color: "#96385C", desc: "La carte passe automatiquement dans « À relancer (3ème relance) » 4 jours après.", delay: { value: 4, unit: "j" }, autoTo: "arelancer3" },
  { id: "arelancer3", title: "À relancer (3ème relance)", color: "#7B113A", desc: "Envoie ta 3ème et dernière relance, puis glisse la carte dans « 3ème relance faite ».", todo: true },
  { id: "relance3", title: "3ème relance faite ✅", color: "#5E3A4A", desc: "Dernière relance envoyée. Sans réponse après 4 jours, passe la carte en « Abandonné ».", delay: { value: 4, unit: "j" }, overdueKind: "stale" },
  { id: "appel", title: "Appel réservé", color: "#C49A5A", desc: "Un appel de vente est booké." },
  { id: "noshow", title: "No-show", color: "#A8556B", desc: "Le prospect ne s'est pas présenté à l'appel. À relancer IMMÉDIATEMENT pour rebooker. Une fois rebooké, remets la carte dans « Appel réservé ».", delay: { value: 0, unit: "h" } },
  { id: "gagne", title: "Closé", color: "#590224", desc: "Client signé.", won: true },
  { id: "perdu", title: "Abandonné", color: "#9A8F8A", desc: "Pas de réponse ou non catégorique." },
];
export const COL = Object.fromEntries(COLUMNS.map((c) => [c.id, c]));
export const CLIENT_DEFAULTS = { price: 0, saleType: "mensuel" };
export const SALE_TYPES = { mensuel: "Abonnement mensuel", unique: "Paiement unique" };

export const defaultDelays = () => Object.fromEntries(COLUMNS.filter((c) => c.delay).map((c) => [c.id, { ...c.delay }]));
export const defaultState = () => ({ version: 1, cards: [], settings: { delays: defaultDelays() }, templates: {}, ui: { collapsed: {} } });

function normalizeCard(c) {
  if (!c || typeof c !== "object" || !c.id) return null;
  const at = c.createdAt || c.enteredAt || new Date().toISOString();
  return { ...c, column: COL[c.column] ? c.column : START_COLUMN, instagram: c.instagram || "", link: c.link || "", prenom: c.prenom || "", nom: c.nom || "", notes: c.notes || "",
    history: Array.isArray(c.history) ? c.history : [], noShowCount: c.noShowCount || 0, lastRelanceAt: c.lastRelanceAt || null, createdAt: at, enteredAt: c.enteredAt || at, client: c.client || null };
}
export function normalizeState(s) {
  const base = defaultState();
  if (!s || typeof s !== "object") return base;
  return { version: 1, cards: Array.isArray(s.cards) ? s.cards.map(normalizeCard).filter(Boolean) : [],
    settings: { delays: { ...base.settings.delays, ...(s.settings?.delays || {}) } }, templates: { ...(s.templates || {}) }, ui: { collapsed: { ...(s.ui?.collapsed || {}) } } };
}

const pad = (n) => String(n).padStart(2, "0");
export const uid = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
export const fmtShort = (iso) => { const d = new Date(iso); return `${pad(d.getDate())}/${pad(d.getMonth() + 1)} à ${pad(d.getHours())}h${pad(d.getMinutes())}`; };
export const fmtDate = (iso) => { const d = new Date(iso); return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`; };
export const fmtFull = (iso) => { const d = new Date(iso); return `${fmtDate(iso)} à ${pad(d.getHours())}h${pad(d.getMinutes())}`; };
export function fmtDuration(ms) {
  const totalH = Math.floor(Math.max(0, ms) / 3600e3);
  const d = Math.floor(totalH / 24), h = totalH % 24;
  if (d > 0) return `${d} j ${h} h`;
  return totalH > 0 ? `${totalH} h` : "moins d'1 h";
}
export const fmtEuro = (n) => `${new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 }).format(n || 0)} €`;
export const plural = (n, w) => `${n} ${w}${n > 1 ? "s" : ""}`;
export const normHandle = (v) => String(v || "").trim().replace(/^https?:\/\/(www\.)?instagram\.com\//i, "").replace(/[/?#].*$/, "").replace(/^@+/, "").replace(/\s+/g, "");
export const fold = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
export const rgba = (hex, a) => { const n = parseInt(hex.slice(1), 16); return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`; };
export const fullName = (c) => [c.prenom, c.nom].filter(Boolean).join(" ") || "Sans prénom";
export const igUrl = (c) => c.link || `https://instagram.com/${encodeURIComponent(c.instagram)}`;

export function delayHours(state, colId) {
  const d = state.settings.delays[colId];
  if (!COL[colId]?.delay || !d) return null;
  const v = Math.max(0, Number(d.value) || 0);
  return d.unit === "h" ? v : v * 24;
}
export function timing(state, card, now = Date.now()) {
  const hrs = delayHours(state, card.column);
  if (hrs === null) return null;
  let ref = Date.parse(card.enteredAt);
  if (COL[card.column].recurring && card.lastRelanceAt) ref = Math.max(ref, Date.parse(card.lastRelanceAt));
  const deadline = ref + hrs * 3600e3;
  return { overdue: now >= deadline, diff: Math.abs(now - deadline), deadline };
}
export function moveCardState(state, id, colId, auto = false) {
  const at = new Date().toISOString();
  return { ...state, cards: state.cards.map((c) => {
    if (c.id !== id || c.column === colId || !COL[colId]) return c;
    const n = { ...c, column: colId, enteredAt: at, history: [...c.history, { type: "move", column: colId, at, ...(auto ? { auto: true } : {}) }] };
    if (colId === "noshow") n.noShowCount = (c.noShowCount || 0) + 1;
    if (COL[colId].won) n.client = c.client ? { ...c.client, signedAt: c.client.signedAt || at } : { ...CLIENT_DEFAULTS, active: true, signedAt: at, stoppedAt: null };
    return n;
  }) };
}

export function applyAuto(state, now = Date.now()) {
  let changed = false;
  const cards = state.cards.map((c) => {
    const col = COL[c.column];
    const hrs = delayHours(state, c.column);
    if (!col?.autoTo || hrs === null) return c;
    const due = Date.parse(c.enteredAt) + hrs * 3600e3;
    if (now < due) return c;
    changed = true;
    const at = new Date(due).toISOString();
    return { ...c, column: col.autoTo, enteredAt: at, history: [...c.history, { type: "move", column: col.autoTo, at, auto: true }] };
  });
  return changed ? { ...state, cards } : null;
}
